"use client";

import { useTranslations } from "next-intl";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/ui/alert-dialog";

interface ClosePostSuggestionProps {
  /** id объявления из ссылки уведомления `/lfg?closePost=…`; null — не показываем. */
  postId: string | null;
  onDismiss: () => void;
  onConfirm: (postId: string) => void;
}

/** Игрока взяли в команду — спрашиваем, закрыть ли его «Ищу команду» (решение 28.09.2026: не закрывать молча). */
export function ClosePostSuggestion({ postId, onDismiss, onConfirm }: ClosePostSuggestionProps) {
  const t = useTranslations("LfgBoard");
  return (
    <AlertDialog open={postId !== null} onOpenChange={(open) => !open && onDismiss()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("apps.closeSuggestTitle")}</AlertDialogTitle>
          <AlertDialogDescription>{t("apps.closeSuggestText")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("apps.closeSuggestKeep")}</AlertDialogCancel>
          <AlertDialogAction onClick={() => postId && onConfirm(postId)}>{t("apps.closeSuggestConfirm")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
